import { render, staticRenderFns } from "./EnableNotifications.vue?vue&type=template&id=fc070f2a&scoped=true&"
import script from "./EnableNotifications.vue?vue&type=script&lang=js&"
export * from "./EnableNotifications.vue?vue&type=script&lang=js&"
import style0 from "./EnableNotifications.vue?vue&type=style&index=0&id=fc070f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc070f2a",
  null
  
)

export default component.exports